import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { AdjustIcon } from '@moia-dev/pace-icons'
import { VehicleGroupAreaRoutes } from './VehicleGroupAreaRoutes'

export const VehicleGroupAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleGroupAreaRoutes.route}
      Icon={AdjustIcon}
    />
  )
}
